import { createAction, handleActions } from 'redux-actions';

export interface BrandingResponse {
  default: boolean
}

export type BrandingState = {
  isLoading: boolean
  failed: boolean
  default: boolean
} | {
  isLoading: false
  failed: false
  default: boolean
} | {
  isLoading: false
  failed: true
  default: boolean
};

export const fetchOrganizationBrandingInitialized = createAction(
  '@platform/query/organization/getBranding/init',
);
export const fetchOrganizationBrandingSucceeded = createAction(
  '@platform/query/organization/getBranding/success',
  (payload: BrandingResponse) => payload,
);
export const fetchOrganizationBrandingFailed = createAction(
  '@platform/query/organization/getBranding/failed',
);

const initialState: BrandingState = {
  isLoading: true,
  failed: false,
  default: false,
};

export default handleActions<BrandingState, BrandingResponse>({
  [fetchOrganizationBrandingInitialized.toString()]: state => ({
    ...state,
    isLoading: true,
    failed: false,
  }),
  [fetchOrganizationBrandingSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: false,
    failed: false,
    default: payload.default,
  }),
  [fetchOrganizationBrandingFailed.toString()]: () => ({
    ...initialState,
    isLoading: false,
    failed: true,
  }),
}, initialState);
